<template>
  <f7-page>
    <div
      class="sm:flex justify-between my-4 mx-10"
    >
      <div class="relative">
        <div
          class="flex items-center justify-between text-white bg-purple-500 rounded-md cursor-pointer"
          @click="showCalendar = !showCalendar"
        >
          <div
            class="text-2xl font-bold p-2 rounded"
          >
            {{ formattedDate }}
          </div>
          <eva-icon
            :name="showCalendar ? 'arrow-ios-downward-outline' : 'arrow-ios-forward-outline'"
            fill="#FFFFFF"
          />
        </div>
        <div class="absolute mt-2 shadow-lg z-50">
          <vc-date-picker
            v-if="showCalendar"
            v-model="dates"
            is-range
            :value="null"
            color="purple"
            :attributes="attributes"
            :max-date="new Date()"
          />
        </div>
      </div>
      <div
        class="mt-2 sm:mt-0 flex justify-start"
      >
        <a
          class="h-12 cursor-pointer text-white bg-purple-500 flex px-4 py-2 rounded-md items-center text-md mx-2"
          @click="exportAccessRegistrations"
        >
          <eva-icon
            name="cloud-download-outline"
            fill="#FFFFFF"
          />
        </a>
        <a
          v-if="realTime"
          class="h-12 cursor-pointer text-white bg-purple-500 flex px-4 py-2 rounded-md items-center text-md mx-2"
          @click="realTime = !realTime"
        >
          <eva-icon
            name="pause-circle-outline"
            fill="#FFFFFF"
          />
          <div
            class="block-inline text-center ml-2"
          >
            Pausar
          </div>
        </a>
        <a
          v-else
          class="cursor-pointer text-white bg-green-500 flex px-4 py-2 rounded-md items-center text-md mx-2"
          @click="realTime = !realTime"
        >
          <eva-icon
            name="play-circle-outline"
            fill="#FFFFFF"
          />
          <div
            class="block-inline text-center ml-2"
          >
            Renaudar <span class="p-2 bg-green-600 ml-2 rounded-md font-bold">{{ buffer.length }}</span>
          </div>
        </a>
      </div>
    </div>
    <div
      v-if="instancesInfo[instanceID].tags"
      class="mb-4 mx-10 shadow rounded-md p-2"
    >
      <div>
        Filtra por etiquetas
      </div>
      <b class="text-blue-500 text-lg">{{ resultLength }}</b> resultados
      <tag-manager
        :disabled="false"
        :success="false"
        :selectableTags="instancesInfo[instanceID].tags"
        :currentTags="currentTags"
        :rules="{ regex: /^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\-' ]*$/ }"
        @tag:add="addTag"
        @tag:remove="removeTag"
        @state:search="isSearching = $event"
      />
    </div>
    <div class="flex flex-wrap justify-start mb-5 mx-10">
      <div
        :class="`p-2 text-xl w-48 cursor-pointer m-1 text-center shadow-md rounded-sm ${view === 'consolidated' ? 'bg-purple-500 text-white' : ''}`"
        @click="view = 'consolidated'"
      >
        Consolidado
      </div>
      <div
        :class="`p-2 text-xl w-48 cursor-pointer m-1 text-center shadow-md rounded-sm ${view === 'detailed' ? 'bg-purple-500 text-white' : ''}`"
        @click="view = 'detailed'"
      >
        Detalle
      </div>
      <div
        :class="`p-2 text-xl w-48 cursor-pointer m-1 text-center shadow-md rounded-sm ${view === 'persons' ? 'bg-purple-500 text-white' : ''}`"
        @click="view = 'persons'"
      >
        Sin registro hoy
      </div>
    </div>
    <div
      class="mx-10"
    >
      <label
        v-if="view === 'persons'"
        class="h-12 block text-center shadow-md my-0 px-0 relative rounded-md mb-2"
      >
        <eva-icon
          class="absolute left-0 my-2 mx-2"
          name="search-outline"
          fill="#282A43"
        />
        <input
          class="text-md font-bold w-full h-full px-10 text-purple-500 border-2 border-purple-500 border-opacity-0 focus:border-opacity-100 rounded-md"
          type="text"
          placeholder="Buscar"
          :value="searchValue"
          @input="doSearch"
        >
      </label>
      <generic-table
        ref="genericTable"
        :rows="tableRows"
        :columns="tableColumns"
        :exporting="true"
        :readOnly="true"
      />
    </div>
  </f7-page>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment-timezone'
import { db } from '../utils/firebase'
import RegistrationTableRow from '../components/registrationTableRow'
import genericTable from '../components/genericTable'
import tagManager from '../components/tagManager'
import XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import { search } from 'ss-search'
import { myTemplate } from '../components/exit.jsx'

export default {
  components: {
    tagManager,
    genericTable,
  },
  data () {
    return {
      searchValue: '',
      currentTags: {},
      dates: {
        start: null,
        end: null,
      },
      itemComponent: RegistrationTableRow,
      binding: null,
      accessRegistrations: [],
      realTime: true,
      buffer: [],
      showCalendar: false,
      attributes: [
        {
          key: 'today',
          dot: 'purple',
          dates: [new Date()],
        }
      ],
      view: 'consolidated',
    }
  },
  computed: {
    instanceTimezone () {
      return this.instancesInfo[this.instanceID].timeZone
    },
    resultLength () {
      if (this.view === 'detailed' || this.view === 'consolidated') {
        return this.filteredAccessRegistrations.length
      }
      if (this.view === 'persons') {
        return this.notRegisteredToday.length
      }
      return 0
    },
    notRegisteredToday () {
      let persons = this.persons.filter(person => this.wasNotToday(person))
      if (Object.keys(this.currentTags).length !== 0) {
        persons = persons.filter(person => {
          if (typeof person.tagIDs === 'undefined') return false
          return Object.keys(this.currentTags).some(tag => Object.keys(person.tagIDs).includes(tag))
        })
      }
      persons = persons.map(person => {
        return {
          name: person.name,
          dialCode: person.dialCode,
          nationalPhoneNumber: person.nationalPhoneNumber,
          lastAccessRegistration: person.lastAccessRegistration && Object.prototype.hasOwnProperty.call(person.lastAccessRegistration, 'toDate') ? moment(person.lastAccessRegistration.toDate()).tz(this.instanceTimezone).format('YYYY-MM-DD') : '-',
          documentID: person.documentID,
          email: person.email,
          tagIDs: person.tagIDs,
          id: person.id,
        }
      })
      const searchKeys = ['name', 'email', 'nationalPhoneNumber', 'documentID']
      const searchText = this.searchValue
      const results = search(persons, searchKeys, searchText)
      return results
    },
    consolidated () {
      const dates = this.enumerateDaysBetweenDates(this.dates.start, this.dates.end)
      const tagTotals = { statusClass: 'bg-purple-200', date: 'Total', total: 0 }
      const registrations = JSON.parse(JSON.stringify(this.accessRegistrations))
      const consolidated = dates.map(date => {
        const parsed = { date }
        const dateRegistrations = registrations.filter((registration) => {
          return registration.date === date
        })
        let total = 0
        if (!Object.keys(this.currentTags).length) {
          total = dateRegistrations.length || 0
          tagTotals.total = dateRegistrations.length || 0
        }
        for (const tagID of Object.keys(this.currentTags)) {
          const dateTagRegistrations = search(dateRegistrations, ['tagIDs'], tagID)
          total += dateTagRegistrations.length || 0
          parsed[tagID] = dateTagRegistrations.length || 0
        }
        return { ...parsed, total }
      })
      for (const tagID of Object.keys(this.currentTags)) {
        const copy = JSON.parse(JSON.stringify(this.accessRegistrations))
        const tagRegistrations = search(copy, ['tagIDs'], tagID)
        tagTotals[tagID] = tagRegistrations.length
        tagTotals.total += tagRegistrations.length || 0
      }
      return [...consolidated, tagTotals]
    },
    tableColumns () {
      if (this.view === 'detailed') {
        return [
          {
            prop: 'date',
            name: 'Fecha',
            size: 120,
          },
          {
            prop: 'hour',
            name: 'Hora',
            size: 130,
          },
          ...(this.instancesInfo[this.instanceID].exitEnabled ? [{
            prop: 'exit',
            name: 'Sentido',
            size: 90,
            cellTemplate: myTemplate,
          }] : []),
          {
            prop: 'type',
            name: 'Tipo',
            size: 80,
          },
          {
            prop: 'name',
            name: 'Nombre',
            size: 200,
          },
          {
            prop: 'documentID',
            name: 'Documento',
            size: 150,
          },
          {
            prop: 'temperature',
            name: 'Temp (°C)',
            size: 100,
          },
          {
            prop: 'extra',
            name: 'Contacto emergencia',
            size: 300,
            cellTemplate: (createElement, props) => {
              const extra = typeof props.model[props.prop] !== 'undefined' ? `${props.model[props.prop].contactName}: ${props.model[props.prop].contactPhoneNumber}` : ''
              return createElement('div', {},
                [
                  extra
                ]
              )
            },
          }
        ]
      } else if (this.view === 'consolidated') {
        const tags = Object.keys(this.currentTags).map(tagID => {
          return {
            prop: tagID,
            name: this.tags[tagID],
            size: 90,
          }
        })
        return [
          {
            prop: 'date',
            name: 'Fecha',
            size: 120,
          },
          ...tags,
          {
            prop: 'total',
            name: 'Total',
            size: 90,
          }
        ]
      } else {
        return [
          {
            prop: 'name',
            name: 'Nombre',
            size: 200,
          },
          {
            prop: 'documentID',
            name: 'Documento',
            size: 150,
          },
          {
            prop: 'lastAccessRegistration',
            name: 'Último ingreso',
            sortable: true,
            size: 200,
          }
        ]
      }
    },
    tableRows () {
      if (this.view === 'detailed') {
        return this.filteredAccessRegistrations
      } else if (this.view === 'consolidated') {
        return this.consolidated
      } else {
        return this.notRegisteredToday
      }
    },
    filteredAccessRegistrations () {
      if (Object.keys(this.currentTags).length === 0) {
        return this.accessRegistrations
      }
      return this.accessRegistrations.filter(registration => {
        if (typeof registration.tagIDs === 'undefined') return false
        return Object.keys(this.currentTags).some(tag => registration.tagIDs.includes(tag))
      })
    },
    formattedDate () {
      return moment(this.dates.start).tz(this.instanceTimezone).format('DD MMM YYYY') + ((this.dates.end - this.dates.start >= 24 * 60 * 60 * 1000) ? ' - ' + moment(this.dates.end).tz(this.instanceTimezone).format('DD MMM YYYY') : '')
    },
    timestamp () {
      return moment(this.date).tz(this.instanceTimezone).format('x')
    },
    temperatureLimit () {
      return this.instancesInfo[this.instanceID].dictionary.parameters.temperatureLimit || 38
    },
    ...mapState({
      instanceID: state => state.admin.instanceID,
      persons: state => state.admin.persons,
      instancesInfo: state => state.auth.instancesInfo,
    }),
    ...mapGetters({
      tags: 'admin/tags',
    }),
  },
  watch: {
    realTime: function (val) {
      if (val && this.buffer.length > 0) {
        this.accessRegistrations = [...this.buffer, ...this.accessRegistrations]
        this.buffer = []
      }
    },
    dates: function () {
      this.showCalendar = false
      this.bind()
    },
  },
  mounted () {
    this.dates = {
      start: moment().tz(this.instanceTimezone).startOf('day').toDate(),
      end: moment().tz(this.instanceTimezone).startOf('day').toDate(),
    }
    this.bind()
  },
  beforeDestroy () {
    if (this.binding) this.binding()
  },
  methods: {
    doSearch (e) {
      this.searchValue = e.target.value
    },
    wasNotToday (person) {
      if (!person.lastAccessRegistration) {
        return true
      }
      if (typeof person.lastAccessRegistration !== 'undefined' && Object.prototype.hasOwnProperty.call(person.lastAccessRegistration, 'toDate')) {
        return !(moment(person.lastAccessRegistration.toDate()).tz(this.instanceTimezone).startOf('day').format('x') === moment().tz(this.instanceTimezone).startOf('day').format('x'))
      }
      return true
    },
    enumerateDaysBetweenDates (startDate, endDate) {
      var dates = []
      var currDate = moment(startDate).startOf('day')
      var lastDate = moment(endDate).startOf('day')
      dates.push(currDate.clone().format('YYYY-MM-DD'))
      while (currDate.add(1, 'days').diff(lastDate) <= 0) {
        dates.push(currDate.clone().format('YYYY-MM-DD'))
      }
      return dates
    },
    addTag (tagID) {
      if (tagID) {
        if (!this.currentTags[tagID]) {
          this.$set(this.currentTags, tagID, this.tags[tagID])
        }
      }
    },
    removeTag (tagID) {
      this.$delete(this.currentTags, tagID)
    },
    bind () {
      this.accessRegistrations = []
      if (this.binding) this.binding()
      this.realTime = true
      const endDate = moment(this.dates.end).tz(this.instanceTimezone).endOf('day').toDate()
      this.binding = db.collection('accessRegistrations').where('instanceID', '==', this.instanceID).where('timeStamp', '>=', this.dates.start).where('timeStamp', '<=', endDate).orderBy('timeStamp', 'asc').onSnapshot(accessRegistrationsQueries => {
        accessRegistrationsQueries.docChanges().forEach(change => {
          if (change.type === 'added') {
            const accessRegistration = change.doc.data()
            const registration = {
              id: change.doc.id,
              name: accessRegistration.name,
              documentID: accessRegistration.documentID,
              temperature: accessRegistration.details.temperature,
              personID: accessRegistration.personID,
              tagIDs: accessRegistration.tagIDs ? accessRegistration.tagIDs : [],
              time: accessRegistration.timeStamp,
              type: accessRegistration.type || 'N/A',
              hour: moment(accessRegistration.timeStamp.toDate()).tz(this.instanceTimezone).format('hh:mm:ss A'),
              date: moment(accessRegistration.timeStamp.toDate()).tz(this.instanceTimezone).format('YYYY-MM-DD'),
              extra: accessRegistration.extra,
              exit: accessRegistration.exit,
              registeredBy: accessRegistration.registeredBy,
            }
            if (this.realTime) {
              this.accessRegistrations.unshift(registration)
            } else {
              this.buffer.unshift(registration)
            }
          }
        })
      })
    },
    exportAccessRegistrations () {
      if (!this.persons || !this.filteredAccessRegistrations) {
        return
      }
      const date = moment(this.date).tz(this.instanceTimezone).startOf('day').format('DD-MM-YY')
      if (this.view !== 'detailed') {
        const grid = this.$refs.genericTable.$refs.grid.$refs.grid
        grid.getPlugins().then(plugins => {
          plugins.forEach(p => {
            if (p.exportFile) {
              const exportPlugin = p
              exportPlugin.exportFile({ filename: `${this.view}-${date}` })
            }
          })
        })
        return
      }
      const wb = XLSX.utils.book_new()
      const name = `Detalles-${date}.xlsx`
      const complete = [
        ['Fecha', 'tipo', 'Hora', 'Evento', 'Nombre', 'ID', 'Temperatura', 'Etiquetas', 'Encargado'],
        ...this.filteredAccessRegistrations.map(registration => {
          const person = this.persons.find(person => {
            return person.id === registration.personID
          })
          const registeredBy = this.persons.find(person => {
            return person.userID === registration.registeredBy
          })
          if (!person) {
            return []
          }
          const time = moment(registration.time.toDate()).tz(this.instanceTimezone).format('hh:mm:ss A')
          const date = moment(registration.time.toDate()).tz(this.instanceTimezone).format('YYYY-MM-DD')
          const tags = person.tagIDs ? Object.keys(person.tagIDs).map(tagID => { return this.tags[tagID] }).sort().join(', ') : ''
          const event = typeof registration.exit !== 'undefined' ? registration.exit ? 'Salida' : 'Entrada' : 'N/A'
          return [date, registration.type, time, event, person.name, person.documentID, registration.temperature, tags, registeredBy?.documentID || '']
        }).reverse()
      ]
      const w1 = XLSX.utils.aoa_to_sheet(complete)
      XLSX.utils.book_append_sheet(wb, w1, 'registros')

      const wopts = { bookType: 'xlsx', bookSST: false, type: 'array' }
      const wbout = XLSX.write(wb, wopts)
      const xlsx = new Blob([wbout], { type: 'application/octet-stream' })
      saveAs(xlsx, name)
    },
  },
}
</script>
